export default "__VITE_ASSET__DufhtJ28__"